import { orderBy } from "lodash-es";

import type { AssistantTaskNoteReferenceModelData } from "@/store/assistant/types";
import type { INoteObservable } from "@/store/note/types";
import { getAgentTimestamp } from "@/pages/agent/utils/agent-date.utils";

export type TaskSourceReference = {
  modelData: Pick<AssistantTaskNoteReferenceModelData, "note_id" | "task_id">;
};

export type TaskSourceNote = Pick<INoteObservable, "id" | "isAvailable" | "modifiedAt" | "title"> &
  Partial<Pick<INoteObservable, "createdAt" | "secondaryTitle">>;

export const resolveTaskSourceNotes = ({
  references,
  getNoteById,
}: {
  references: TaskSourceReference[];
  getNoteById: ({
    noteId,
  }: {
    noteId: AssistantTaskNoteReferenceModelData["note_id"];
  }) => TaskSourceNote | undefined;
}) => {
  const availableNotes = references.flatMap(reference => {
    const note = getNoteById({ noteId: reference.modelData.note_id });

    return note?.isAvailable ? [note] : [];
  });

  return orderBy(
    availableNotes,
    [note => getAgentTimestamp({ value: note.modifiedAt, fallback: 0 }), note => note.id],
    ["desc", "asc"]
  );
};
